import { ReactNode } from 'react'
import { formatDateToPtBr } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { DispositivoGestaoView } from '../../core/_models'
import {
  rotuloClasseRisco,
  rotuloMotivoBaixa,
  rotuloRegime,
  rotuloSituacao,
  rotuloTipo,
} from '../../core/rotulos'

const Campo = ({ rotulo, valor }: { rotulo: string; valor?: ReactNode }) => {
  const vazio = valor === undefined || valor === null || valor === ''
  return (
    <div className='col-md-4 col-sm-6'>
      <dt className='fs-7 fw-semibold text-gray-700 mb-1'>{rotulo}</dt>
      <dd className='text-gray-900 mb-0'>{vazio ? <span title='—'>—</span> : valor}</dd>
    </div>
  )
}

const Grupo = ({ titulo, children }: { titulo: string; children: ReactNode }) => (
  <section className='mb-8'>
    <h3 className='fs-6 fw-semibold text-gray-900 mb-4'>{titulo}</h3>
    <dl className='row g-4 mb-0'>{children}</dl>
  </section>
)

/** Todos os campos do cadastro, só leitura, agrupados como no modal. */
export const DadosAba = ({ dispositivo: d }: { dispositivo: DispositivoGestaoView }) => {
  const { t } = useT()
  const c = (chave: string) => t(`pagina.dispositivos.campo.${chave}`)

  return (
    <>
      <Grupo titulo={t('pagina.dispositivos.secao.identificacao')}>
        <Campo rotulo={c('empresa')} valor={d.empresa?.nome} />
        <Campo rotulo={c('tipo')} valor={rotuloTipo(t, d.tipo)} />
        <Campo rotulo={c('serie')} valor={d.serie} />
        <Campo rotulo={c('fabricante')} valor={d.fabricante} />
        <Campo rotulo={c('modelo')} valor={d.modelo} />
        <Campo rotulo={c('patrimonio')} valor={d.patrimonio} />
        <Campo rotulo={c('mac')} valor={d.macAddress} />
        <Campo rotulo={c('firmware')} valor={d.firmware} />
      </Grupo>
      <Grupo titulo={t('pagina.dispositivos.secao.regulatorio')}>
        <Campo rotulo={c('registro_anvisa')} valor={d.registroAnvisa} />
        <Campo
          rotulo={c('registro_anvisa_validade')}
          valor={formatDateToPtBr(d.registroAnvisaValidade)}
        />
        <Campo rotulo={c('classe_risco')} valor={rotuloClasseRisco(t, d.classeRisco)} />
        <Campo rotulo={c('certificacao_anatel')} valor={d.certificacaoAnatel} />
        <Campo rotulo={c('certificacao_inmetro')} valor={d.certificacaoInmetro} />
        <Campo rotulo={c('lote')} valor={d.lote} />
        <Campo rotulo={c('udi_di')} valor={d.udiDi} />
        <Campo rotulo={c('udi_pi')} valor={d.udiPi} />
      </Grupo>
      <Grupo titulo={t('pagina.dispositivos.secao.aquisicao')}>
        <Campo rotulo={c('fornecedor')} valor={d.fornecedor?.nome} />
        <Campo rotulo={c('nota_fiscal')} valor={d.notaFiscal} />
        <Campo rotulo={c('dt_aquisicao')} valor={formatDateToPtBr(d.dtAquisicao)} />
        <Campo rotulo={c('garantia_ate')} valor={formatDateToPtBr(d.garantiaAte)} />
        <Campo rotulo={c('regime')} valor={rotuloRegime(t, d.regime)} />
      </Grupo>
      <Grupo titulo={t('pagina.dispositivos.secao.calibracao')}>
        <Campo
          rotulo={c('periodicidade')}
          valor={
            d.periodicidadeCalibracaoMeses != null
              ? t('pagina.dispositivos.meses', { meses: d.periodicidadeCalibracaoMeses })
              : ''
          }
        />
        <Campo rotulo={c('dt_ultima_calibracao')} valor={formatDateToPtBr(d.dtUltimaCalibracao)} />
        <Campo
          rotulo={c('dt_proxima_calibracao')}
          valor={formatDateToPtBr(d.dtProximaCalibracao)}
        />
      </Grupo>
      <Grupo titulo={t('pagina.dispositivos.secao.situacao')}>
        <Campo rotulo={c('situacao')} valor={rotuloSituacao(t, d.situacao)} />
        <Campo rotulo={c('motivo_baixa')} valor={rotuloMotivoBaixa(t, d.motivoBaixa)} />
        <Campo rotulo={c('dt_baixa')} valor={formatDateToPtBr(d.dtBaixa)} />
        <Campo rotulo={c('destino_baixa')} valor={d.destinoBaixa} />
      </Grupo>
      <Grupo titulo={c('observacoes')}>
        <div className='col-12'>
          <dd className='text-gray-900 mb-0' style={{ whiteSpace: 'pre-wrap' }}>
            {d.observacoes || <span title='—'>—</span>}
          </dd>
        </div>
      </Grupo>
    </>
  )
}
